import request from "root/js/request";

const getSppAnalyticsPrices = async ({
  limit,
  offset,
  product_id,
  subject_id,
  subject_id__in,
  price__gte,
  price__lte,
  discount__gte,
  discount__lte,
  wb_api_key_ids,
  available_to_monitor,
  price_with_discount__gte,
  price_with_discount__lte,
  create_date_gte,
  create_date_lte,
  create_date__gte,
  create_date__lte,
  ...rest
}) => {
  const response = await request({
    url: `/analytics/prices/`,
    method: "get",
    params: {
      limit,
      offset,
      product_id,
      subject_id,
      subject_id__in,
      price__gte,
      price__lte,
      discount__gte,
      discount__lte,
      wb_api_key_ids,
      available_to_monitor,
      price_with_discount__gte,
      price_with_discount__lte,
      create_date__gte: create_date_gte ?? create_date__gte,
      create_date__lte: create_date_lte ?? create_date__lte,
      ...rest,
    },
  });
  return response.data;
};

export { getSppAnalyticsPrices };
